<div class="searchbar-whereapp">
    <div id="inserisci-utenza-div">
        <button id="inserisci-utenza-button" (click)="insertUserDialog()">
            <mat-icon aria-hidden="false" id="inserisci-utenza-icon">add</mat-icon>
            <span id="inserisci-utenza-text">Inserisci Utenza</span>
        </button>
    </div>

    <div id="search-div">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <input spellcheck="false" type="text" #filter [(ngModel)]="filterValue" placeholder="Filtra per parole chiave"
            (keydown)="onSearchKeydown($event)">
        <i class="fa fa-times" aria-hidden="true" (click)="onFilterClear();onFiltering()"></i>
        <button mat-stroked-button (click)="onFiltering()" class="ml-2" [disabled]="filterValue.length < 4 && filterValue.length > 0">Cerca</button>
    </div>

    <div id="pagination-div">
        <mat-paginator #paginator [hidePageSize]="true" [pageIndex]="pageable.pageable.pageNum"
            [pageSize]="pageable.pageable.pageSize" [length]=totalElements (page)="onPagination($event)"
            [showFirstLastButtons]="true">
        </mat-paginator>
    </div>

</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div class="empty-list" *ngIf="emptyList">
    <span>Nessun operatore trovato.</span>
</div>

<div id="main-container">
    <!-- Tabella utenti -->
    <mat-table [dataSource]="dataSource" matSort [matSortActive]="paginatorConfig.getFilterColumn()" [matSortDirection]="paginatorConfig.getFilterDirection()" [matSortStart]="paginatorConfig.getFilterDirection()" matSortDisableClear
    (matSortChange)="onSortChange($event)">
        <!-- Username -->
        <ng-container matColumnDef="username">
            <mat-header-cell *matHeaderCellDef fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large"
                mat-sort-header>
                Username </mat-header-cell>
            <mat-cell *matCellDef="let user" fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large">
                {{user.username}} <span *ngIf="!(user.enabled)">&nbsp;<b>(disabilitato)</b></span>
            </mat-cell>
        </ng-container>
        <!-- Ruolo -->
        <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef fxFlex="20%" fxFlex.sm="20%" fxFlex.xs="20%" class="mobile-large">
                Ruolo
            </mat-header-cell>
            <mat-cell *matCellDef="let user" fxFlex="20%" fxFlex.sm="20%" fxFlex.xs="20%" class="mobile-large">
                {{ user.roles[0].description }}
            </mat-cell>
        </ng-container>
        <!-- Email -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef fxFlex="25%" fxFlex.sm="25%" fxFlex.xs="25%" class="mobile-large"
                mat-sort-header>
                Email
            </mat-header-cell>
            <mat-cell *matCellDef="let user" fxFlex="25%" fxFlex.sm="25%" fxFlex.xs="25%" class="mobile-large">
                {{ user.email }}
            </mat-cell>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef fxFlex="25%" fxFlex.sm="25%" fxFlex.xs="25%" class="mobile-large">
            </mat-header-cell>
            <mat-cell *matCellDef="let user" fxFlex="25%" fxFlex.sm="25%" fxFlex.xs="25%" class="contract-icon">
                <button type="button" mat-stroked-button matTooltip="Dettagli" [matTooltipShowDelay]="600"
                    (click)="onUserDetails(user)">
                    <mat-icon fontSet="material-icons" style="color: grey;">edit</mat-icon>
                </button>
                <button type="button" mat-stroked-button matTooltip="Associazioni Mittenti" [matTooltipShowDelay]="600"
                    (click)="onUserAssociations(user)" style="margin-left: 10px;">
                    <mat-icon fontSet="material-icons" style="color: grey;">link</mat-icon>
                </button>
                <button  *ngIf="!(user.enabled)" type="button" mat-stroked-button matTooltip="Abilita" [matTooltipShowDelay]="600"
                    (click)="onUserEnable(user)" style="margin-left: 10px;">
                    <mat-icon fontSet="material-icons" style="color: grey;">person</mat-icon>
                </button>
                <button  *ngIf="(user.enabled)" type="button" mat-stroked-button matTooltip="Disabilita" [matTooltipShowDelay]="600"
                    (click)="onUserDisable(user)" style="margin-left: 10px;">
                    <mat-icon fontSet="material-icons" style="color: grey;">person_off</mat-icon>
                </button>
                <button type="button" mat-stroked-button matTooltip="Elimina" [matTooltipShowDelay]="600"
                    (click)="onUserDelete(user)" style="margin-left: 10px;">
                    <mat-icon fontSet="material-icons" style="color: grey;">delete</mat-icon>
                </button>
                <!-- <button type="button" mat-stroked-button matTooltip="Operazione proibita." [matTooltipShowDelay]="600"
                    color="warn" style="margin-left: 10px;" (click)="onUserDelete(user)" [disabled]="true">
                    <mat-icon>delete</mat-icon>
                </button> -->
            </mat-cell>
        </ng-container>

        <!-- Impostazione di righe e colonne -->
        <mat-header-row *matHeaderRowDef=" displayedColumns; sticky: true" style="height: 64px">
        </mat-header-row>

        <mat-row class="element-row" *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row>

    </mat-table>
</div>

<div class="loading" *ngIf="sub === true">
</div>